import { SearchPropertyModel } from "../../../../../types/Search";
import * as BucketAggs from "../../templates/bucket-aggregations";
import * as Aggs from "../../templates/aggregations";
import AggregationUtil from "../../../utils/aggregation-util";
import { AggregationType } from "../../../../../types/AggregationType";

export const NUMERIC_AGG_BUCKETS_SIZE = 5;
export const TERMS_AGG_MAX_BUCKETS = 50;

/**
 * Constructs an aggregation query argument from the provided properties.
 *
 * @param {Array<SearchPropertyModel>} properties
 * @returns {string} the query as string
 */
export default function aggregations(properties: Array<SearchPropertyModel>): string {
  const propertiesAggs: Array<string> = [];

  // Filter & insert the provided properties
  const supportedProperties = AggregationUtil.filterSupportedProperties(properties);
  supportedProperties.forEach((property: SearchPropertyModel) => {
    const type = AggregationUtil.resolveAggregationTypeFromRange(property);
    const name = AggregationUtil.buildAggregationName(type, property);

    if (type === AggregationType.NUMERIC_RANGE) {
      propertiesAggs.push(
        BucketAggs.variableWidthHistogram({
          name,
          field: property.name,
          buckets: NUMERIC_AGG_BUCKETS_SIZE
        })
      );
    } else {
      propertiesAggs.push(
        BucketAggs.terms({
          name,
          field: property.name,
          size: TERMS_AGG_MAX_BUCKETS
        })
      );
    }
  });

  return Aggs.aggregations(propertiesAggs);
}
